import { z } from 'zod';

export const embeddedBrandMembershipsFormSchema = z.object({
  brandId: z.string().uuid(),
  isBanned: z.boolean().nullish(),
  role: z.enum(['ADMIN', 'CUSTOMER', 'MODERATOR']),
});

export type EmbeddedBrandMembershipsFormData = z.infer<
  typeof embeddedBrandMembershipsFormSchema
>;

export const userEditFormSchema = z.object({
  brandMemberships: z.array(embeddedBrandMembershipsFormSchema).nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  username: z.string().nullish(),
});

export type UserFormData = z.infer<typeof userEditFormSchema>;
